const getStorageKey = (jobType) => `deliverit.addressOrder.${localStorage.vendorId}.${jobType}`;

export const getAddressOrder = (jobType) => {
  try {
    const stored = localStorage.getItem(getStorageKey(jobType));
    const parsed = stored ? JSON.parse(stored) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

export const saveAddressOrder = (jobType, addresses) => {
  try {
    localStorage.setItem(getStorageKey(jobType), JSON.stringify(addresses.map(addr => addr.id)));
  } catch (e) {
    // storage unavailable, ordering falls back to the order returned by the API
  }
}

export const applyAddressOrder = (addresses, jobType) => {
  if (!addresses || addresses.length === 0) return [];

  const order = getAddressOrder(jobType);
  if (order.length === 0) return [...addresses];

  const ranked = [];
  const unranked = [];

  addresses.forEach(addr => {
    const position = order.indexOf(addr.id);
    if (position === -1) unranked.push(addr);
    else ranked.push({ addr, position });
  });

  return [
    ...ranked.sort((a, b) => a.position - b.position).map(r => r.addr),
    ...unranked
  ];
}

export const reorderAddresses = (addresses, jobType, oldIndex, newIndex) => {
  const reordered = [...addresses];
  const [moved] = reordered.splice(oldIndex, 1);
  reordered.splice(newIndex, 0, moved);

  saveAddressOrder(jobType, reordered);
  return reordered;
}

export const searchAddresses = (addresses, queryString) => {
  const query = (queryString || "").trim().toLowerCase();
  if (query === "") return addresses;

  return addresses.filter(addr =>
    (addr.location?.address || "").toLowerCase().includes(query) ||
    (addr.bookmarkName || "").toLowerCase().includes(query) ||
    (addr.location?.unitNumber || "").toLowerCase().includes(query) ||
    (addr.pickUpPersonName || "").toLowerCase().includes(query) ||
    (addr.pickUpContactNumber || "").toLowerCase().includes(query) ||
    (addr.recipientName || "").toLowerCase().includes(query) ||
    (addr.recipientPhone || "").toLowerCase().includes(query)
  );
}
